import React, { useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  LabelList,
  CartesianGrid,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import PSIcon from '../../PSIcon';

import './index.scss';

const PSInvestmentPerformance = () => {
  const [selected, setSelected] = useState('acumulada');

  const dataSets = {
    acumulada: [
      { id: 1, name: '1 año', value: 6, visualValue: 10 },
      { id: 2, name: '5 años', value: 33, visualValue: 33 },
      { id: 3, name: '10 años', value: 76, visualValue: 76 },
    ],
    anualizada: [
      { id: 1, name: '1 año', value: 6, visualValue: 10 },
      { id: 2, name: '5 años', value: 33, visualValue: 33 },
      { id: 3, name: '10 años', value: 76, visualValue: 76 },
    ],
  };

  const data = dataSets[selected];
  const minVisualValue = 20;
  const chartData = data.map((d) => ({
    ...d,
    visualValue: d.value < minVisualValue ? minVisualValue : d.value,
  }));
  const maxVisualValue = Math.max(...chartData.map((d) => d.visualValue));

  const colors = ['rgba(140, 121, 174, 1)', 'rgba(85, 65, 122, 1)', 'rgba(43, 13, 97, 1)'];

  return (
    <div className="investment-performance">
      <div className="investment-container">
        {/* Bloque izquierdo */}
        <div className="investment-container__info">
          <h2 className="investment-container__info--title">Proyección de su inversión</h2>
          <p className="investment-container__info--desc">
            Su estrategia está pensada a largo plazo. En el <strong>Fondo Balanceado</strong> se
            recomienda evaluar la rentabilidad en un horizonte de 5 años a más.
          </p>

          <div className="investment-container__info--tabs">
            <button
              type="button"
              className={`tab-btn ${selected === 'acumulada' ? 'active' : ''}`}
              onClick={() => setSelected('acumulada')}
            >
              <div>
                <div className="tab-title">Rentabilidad proyectada acumulada</div>
                <div className="tab-subtitle">
                  Los cálculos se han realizado en un escenario conservador.
                </div>
              </div>
              <PSIcon type="arrowRightOrange" className="arrow-left" />
            </button>
            {/* <button
              type="button"
              className={`tab-btn ${selected === 'anualizada' ? 'active' : ''}`}
              onClick={() => setSelected('anualizada')}
            >
              <div className="tab-title">Rentabilidad proyectada anualizada</div>
              <div className="tab-subtitle">Promedio de rendimiento generado por año.</div>
            </button> */}
          </div>
        </div>

        {/* Bloque derecho - gráfico */}
        <div className="investment-container__chart">
          <h3 className="investment-container__chart--title">
            {selected === 'acumulada'
              ? 'Rentabilidad proyectada acumulada'
              : 'Rentabilidad proyectada anualizada'}
          </h3>
          <ResponsiveContainer width="100%" height={200}>
            <BarChart data={chartData} margin={{ top: 5, right: 0, left: 0, bottom: 0 }}>
              <CartesianGrid stroke="#E8E8EF" vertical={false} />

              <XAxis
                dataKey="name"
                tick={{ fill: '#4A4A4A', fontSize: 14 }}
                axisLine={{ stroke: 'rgba(0, 0, 0, 1)', strokeWidth: 1 }}
                tickLine={false}
              />

              <YAxis hide domain={[0, maxVisualValue]} />

              <Bar
                dataKey="visualValue"
                barSize={60}
                radius={[8, 8, 0, 0]}
                isAnimationActive={false}
              >
                {chartData.map((entry) => (
                  <Cell key={entry.id} fill={colors[entry.id - 1]} />
                ))}

                <LabelList
                  dataKey="value"
                  formatter={(v) => `${Number(v).toFixed(2)}%`}
                  position="insideTop"
                  offset={10}
                  style={{
                    fill: '#FFF',
                    fontWeight: 700,
                    fontSize: 12,
                  }}
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="fountain">
        *Los datos mostrados son proyecciones realizadas por Protecta Security{' '}
        <span>sujetas a las fluctuaciones del mercado</span>.
      </div>
    </div>
  );
};

export default PSInvestmentPerformance;
